import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { FormatDatePipe } from '../../../../core/pipe/custom-pipes';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';

@Component({
  selector: 'app-preparation-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    NgSelectModule,
    FormatDatePipe],
  templateUrl: './preparation-form.component.html',
  styleUrl: './preparation-form.component.css'
})
export class PreparationFormComponent {
  @Input() orderData?: any;
  @Input() ladata: any = [];

  @Output() emitOpenAddressesForm = new EventEmitter<boolean>();


  preparationForm: FormGroup;
  delivery_place: any[] = [];
  delivery_status: any[] = [];
  delivery_dealer: any[] = [];
  delivery_urgency_: any[] = ['high', 'medium', 'low', 'custom'];
  workshopData: any[] = [];

  constructor(private fb: FormBuilder, private modelService: ModelService, private alertService: AlertService) {

    this.preparationForm = this.fb.group({
      delivery_current_location: ['', Validators.required],
      delivery_status: [''],
      vehicle_manufacturing_date: [Validators.required],
      vehicle_preparation_document_date: [Validators.required],
      manufacture_expected_date: [Validators.required],
      preparation_start_date: ['', Validators.required],
      preparation_end_date: ['', Validators.required],
      preparation_notes: ['', Validators.required],
      workshop_id: [''],
    });
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.delivery_place = this.ladata.delivery_place;
        this.delivery_status = this.ladata.delivery_status;
        this.workshopData = this.ladata.workshopData;
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }

      if (changes['orderData']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }
    }
  }

  refrescarFormulario() {
    this.updateFieldAccessibility();
    for (const key in this.orderData) {
      const control = this.preparationForm.controls[key];
      const value = this.orderData[key];
      if (control) {
        control.setValue(value);
      }
    }
    this.alertService.close();
  }

  updateFieldAccessibility() {
    var rules = this.orderData?.rules;
    // Deshabilitar todos los campos por defecto
    for (const field in this.preparationForm.controls) {
      if (this.preparationForm.controls.hasOwnProperty(field)) {
        this.preparationForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.preparationForm.get(field)?.enable();
      }
    }

  }

  openAddressesForm() {
    this.emitOpenAddressesForm.emit(true);
  }

  checkUpdateForm(): boolean {
    if (this.preparationForm.dirty) {
      return true;
    } else {
      return false;
    }
  }
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

}
